
import {get,put,post} from '@/utils/request'
import {proxyHeader} from "@/utils/config"


//消息列表
export const getUserMsgList = p => get(proxyHeader+'service/msg-service/notice-receiver/userMsgList', p);

//读取消息
export const readMsg = p => put(proxyHeader+'service/msg-service/notice-receiver/readMsg', p);

//删除纤细
export const deleteMessage = p => post(proxyHeader+'service/msg-service/notice-receiver/deletes', p);

//消息条数
export const getUserMsgNum = p => get(proxyHeader+'service/msg-service/notice-receiver/userMsgNum', p);

